import React, { useState } from 'react';
import css from './LaborAndToolsItemTypesInfoStep2.module.css';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { useProjectStore } from '../../../../../Stores/ProjectStore';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import {
    notifyErrorCustom,
    notifySuccessCustom,
} from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { LaborAndToolsItemsTypesSection } from '@modules/Steps/Shared/Ui/Wrappers/LaborAndToolsItemsTypesSection/LaborAndToolsItemsTypesSection';
import { ItemsTypesTable } from '@modules/Steps/Components/Step2/Step2DesktopContent/FragmentInfoStep2/ItemsTypesTable/ItemsTypesTable';
import { FragmentInfoFooterStep2 } from '@modules/Steps/Components/Step2/Step2DesktopContent/FragmentInfoStep2/FragmentInfoFooterStep2/FragmentInfoFooterStep2';
import { LaborAndToolsItemsTypesHeaderStep2 } from '@modules/Steps/Components/Step2/LaborAndToolsItemTypesInfoStep2/LaborAndToolsItemsTypesHeaderStep2/LaborAndToolsItemsTypesHeaderStep2';
import { ItemTypesListMobile } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/ItemTypesListMobile/ItemTypesListMobile';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { useFragmentsStore } from '../../../../../Stores/FragmentsStore';

interface Props {
    title: string;
    description: string;
    itemTypes: ItemTypeEntity[];
}

export const LaborAndToolsItemTypesInfoStep2: React.FC<Props> = ({
    title,
    description,
    itemTypes,
}) => {
    const { isFragmentsUpdateLoading } = useFragmentsStore();

    const fragmentsViewModel = new FragmentsViewModel();

    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpand = () => {
        setIsExpanded(prev => !prev);
    };

    const [isDesktop] = useMediaType();

    const totalPrice =
        fragmentsViewModel.getTotalForLaborOrToolsItemTypes(itemTypes);

    const handleSave = async () => {
        const response =
            await fragmentsViewModel.updateLaborOrToolsItemTypes(itemTypes);
        if (!response) {
            notifyErrorCustom('Failed to update fragment');
            return;
        }

        notifySuccessCustom('Fragment updated successfully');
    };

    return (
        <LaborAndToolsItemsTypesSection>
            <LaborAndToolsItemsTypesHeaderStep2
                title={title}
                description={description}
                toggleExpand={toggleExpand}
                expanded={isExpanded}
            />
            {isDesktop ? (
                <>
                    <ItemsTypesTable itemTypes={itemTypes} />
                    <FragmentInfoFooterStep2
                        totalPrice={totalPrice}
                        onSave={handleSave}
                        isDisabled={isFragmentsUpdateLoading}
                    />
                </>
            ) : (
                <div
                    className={`${css.laborAndToolsItemTypesMobile} ${isExpanded ? css.showLaborAndTools : ''}`}
                >
                    <ItemTypesListMobile itemTypes={itemTypes} />
                    <FragmentInfoFooterStep2
                        totalPrice={totalPrice}
                        onSave={handleSave}
                        isDisabled={isFragmentsUpdateLoading}
                    />
                </div>
            )}
        </LaborAndToolsItemsTypesSection>
    );
};
